import { types, getParent, flow, cast } from 'mobx-state-tree';
import { LocField } from 'store/localizations/umbraco';
import { CmsApi } from 'service/axios-api';
import { IFeedStore } from '.';

const BannerOne = types.model('BannerOne', {
    Image2: LocField,
    Link: LocField,
    // ShowToNotOwnedUsers: true
    // ShowToOwnedUsers: true
});

const BannerStore = types
    .model('BannersStore', {
        list: types.array(BannerOne),
    })
    .views((self) => ({
        get productId(): string {
            return getParent<IFeedStore>(self).productId;
        },
        get filtered() {
            return self.list.filter((x) => x.Image2.value && x.Link.value);
        },
    }))
    .actions((self) => ({
        fetch: flow(function* () {
            const data = yield CmsApi.get(`/banners/regions/{regionCode}/${self.productId}/list.json`).catch(() => []);
            self.list = cast(data);
        }),
    }));

export default BannerStore;
